import React, { FC } from 'react';
import ReactDiffViewer, { ReactDiffViewerProps } from 'react-diff-viewer';

interface IDiffViewerProps extends ReactDiffViewerProps {}
export const DiffViewer: FC<IDiffViewerProps> = (props) => {
    return <ReactDiffViewer {...props} />;
};
